import { render } from "./LoanDetailsCard.vue?vue&type=template&id=054a496d&scoped=true"
import script from "./LoanDetailsCard.vue?vue&type=script&lang=js"
export * from "./LoanDetailsCard.vue?vue&type=script&lang=js"

import "./LoanDetailsCard.vue?vue&type=style&index=0&id=054a496d&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-054a496d"]])

export default __exports__